import { LoginBonusKind } from '../../../../../services/exports/Constants';

export default {
  [LoginBonusKind.MobileAppSignupBonus]: {
    toast: 'Complimenti! Hai guadagnato {{amount}} di cashback.',
  },
};
